function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#9300FF"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M249.66 0c79.263 0 80.033 73.224 80.04 74.689v114.003l-20.082-26.654-20.01 26.654-19.995-26.654-19.993 26.654-19.994-26.654-19.992 26.654-19.99-26.654-20.025 26.654V74.69c.007-1.465.777-74.689 80.04-74.689zM123.951 7.493v116.311h23.187v29.817h-23.187v31.665H88.555v-31.665H0v-31.665C15.54 92.386 34.904 61.213 71.411 7.493h52.54zm352.861 0v116.311H500v29.817h-23.187v31.665h-35.397v-31.665H352.86v-31.665c15.54-29.57 34.904-60.743 71.411-114.463h52.541zM442.156 33.86h-.74c-20.98 30.739-35.162 52.504-47.462 74.464l-.908 1.627c-2.563 4.612-5.048 9.242-7.501 13.976v.986h56.61V33.86zM287.028 54.723c-8.84 0-16.013 7.171-16.013 16.01 0 8.848 7.173 16.009 16.013 16.009 8.84 0 16.012-7.16 16.012-16.01 0-8.838-7.172-16.01-16.012-16.01zm-74.727 0c-8.84 0-16.012 7.171-16.012 16.01 0 8.848 7.172 16.009 16.012 16.009 8.841 0 16.013-7.16 16.013-16.01 0-8.838-7.172-16.01-16.013-16.01zM32.684 123.927v.986h56.61V33.86h-.74c-25.9 37.95-41.44 62.222-55.87 90.067z",
  transform: "translate(-470 -286) translate(470 286)"
}))));

var Svg404 = function Svg404(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 189,
    viewBox: "0 0 500 189",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404.29260fa9.svg";
export { ForwardRef as ReactComponent };